<div class="meter-validation-root">
    <div class="meter-validation-header row">
        <div class="meter-validation-header-info col-md-4">
            <div class="meter-validation-info">
                <div class="name">{{'METER_VALIDATION.DETAILS.TITLE' | translate}}</div>
                <div class="slrn">{{ selectedMeterValidation.accountNumber }}</div>
                <div class="status-pill" [ngClass]="selectedMeterValidation.status">
                    {{ 'COMMON.ASSET_STATUS.' + selectedMeterValidation.status | uppercase | translate }}
                </div>
            </div>
        </div>
        <div class="col-md-8">
            <div class="row">
                <div class="user-address col-md-4">
                    <div>{{ selectedMeterValidation.customerName }}</div>
                    <div>{{ selectedMeterValidation.address }}</div>
                </div>
                <div class="offset-lg-2 col-lg-6 offset-xl-4 col-xl-4" *ngIf="selectedMeterValidation.status == 'Submitted' && permissionsService.isMeterValidationApproveRejectAllowed">
                    <div class="row">
                        <div class="col-xl-6">
                        <button class="btn btn-outline-danger"
                            data-bs-toggle="modal" data-bs-target="#modalReject">
                            {{'METER_VALIDATION.DETAILS.REJECT' | translate}}
                        </button>
                        </div>
                        <div class="col-xl-6">
                        <button class="btn btn-outline-success"
                            data-bs-toggle="modal" data-bs-target="#modalApprove">
                            {{'METER_VALIDATION.DETAILS.APPROVE' | translate}}
                        </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="meter-validation-header body-header">
        <div class="meter-validation-header-info">
            <div class="meter-validation-info">
                <div class="name">{{'COMMON.CUSTOMER.DETAILS' | translate}}</div>
            </div>
        </div>
    </div>
    <div class="meter-validation-body">
        <div class="row">
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'COMMON.MBC_DETAILS.CUSTOMER_NAME' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ selectedMeterValidation.customerName | hasValue }}
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'COMMON.MBC_DETAILS.CUSTOMER_ADDRESS' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ selectedMeterValidation.address | hasValue }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'COMMON.MBC_DETAILS.PHYSICAL_ADDRESS' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ selectedMeterValidation.physicalAddress | hasValue }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'COMMON.CUSTOMER.ACCOUNT_NUMBER' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ selectedMeterValidation.accountNumber | hasValue }}
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'COMMON.MBC_DETAILS.METER_NO' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ selectedMeterValidation.meterNumber | hasValue }}
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'COMMON.MBC_DETAILS.METER_TYPE.SINGLE' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ selectedMeterValidation.meterType | hasValue }}
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'COMMON.MBC_DETAILS.FEEDER_NAME' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ selectedMeterValidation.feederName | hasValue }}
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'COMMON.DT_NAME' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ selectedMeterValidation.dtName | hasValue }}
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'COMMON.METER_VALIDATION_AREA' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ selectedMeterValidation.district | hasValue }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'COMMON.METER_VALIDATION_REGION' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ selectedMeterValidation.region | hasValue }}
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'COMMON.GEOLOCATION' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text col-10 col-lg-10 col-xxl-6">
                            {{ selectedMeterValidation.latitude }} ,
                            {{ selectedMeterValidation.longitude }}
                        </div>
                        <div class="col-2 col-xl-2 col-xxl-1 geo-icon" (click)="isMapVisible = !isMapVisible">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" data-bs-toggle="modal"
                                data-bs-target="#showMap">
                                <path
                                    d="M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm128 80c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
                                    fill="#026962" />
                            </svg>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="meter-validation-header body-header">
        <div class="meter-validation-header-info">
            <div class="meter-validation-info">
                <div class="name">{{'METER_VALIDATION.DETAILS.INSTALLATION_CONFIRMATION' | translate}}</div>
            </div>
        </div>
    </div>
    <div class="meter-validation-body">
        <div class="row">
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'METER_VALIDATION.DETAILS.INSTALLATION_OKAY_QUESTION' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ (selectedMeterValidation.isInstallationOkay ? 'COMMON.YES' : 'COMMON.NO') | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="meter-validation-header body-header">
        <div class="meter-validation-header-info">
            <div class="meter-validation-info">
                <div class="name">{{'METER_VALIDATION.PICTURES.TITLE' | translate}}</div>
            </div>
        </div>
    </div>
    <div class="meter-validation-body">
        <div class="row">
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card image-card">
                    <div class="row">
                        <div class="col header-title-text">{{'METER_VALIDATION.PICTURES.PICTURE_OF_SEAL' | translate}}</div>
                    </div>
                    <div class="row">
                        <div *ngIf="getImageByType(ImageType.FrontOfBuilding)?.url">
                            <img src="{{ getImageByType(ImageType.FrontOfBuilding)?.url }}"
                                (click)="showImage(ImageType.FrontOfBuilding)" data-bs-toggle="modal"
                                data-bs-target="#modalImage" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card image-card">
                    <div class="row">
                        <div class="col header-title-text">{{'METER_VALIDATION.PICTURES.CUSTOMER_WIRING' | translate}}</div>
                    </div>
                    <div class="row">
                        <div *ngIf="getImageByType(ImageType.LeftSideOfBuilding)?.url">
                            <img src="{{ getImageByType(ImageType.LeftSideOfBuilding)?.url }}"
                                (click)="showImage(ImageType.LeftSideOfBuilding)" data-bs-toggle="modal"
                                data-bs-target="#modalImage" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card image-card">
                    <div class="row">
                        <div class="col header-title-text">{{'METER_VALIDATION.PICTURES.PICTURE_OF_THE_BUILDING' | translate}}</div>
                    </div>
                    <div class="row">
                        <div *ngIf="getImageByType(ImageType.RightSideOfBuilding)?.url">
                            <img src="{{ getImageByType(ImageType.RightSideOfBuilding)?.url }}"
                                (click)="showImage(ImageType.RightSideOfBuilding)" data-bs-toggle="modal"
                                data-bs-target="#modalImage" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card image-card">
                    <div class="row">
                        <div class="col header-title-text">{{'METER_VALIDATION.PICTURES.FULL' | translate}}</div>
                    </div>
                    <div class="row" *ngIf="getImageByType(ImageType.FullViewOfInstalledMeter)?.url">
                        <div>
                            <img src="{{ getImageByType(ImageType.FullViewOfInstalledMeter)?.url }}"
                                (click)="showImage(ImageType.FullViewOfInstalledMeter)" data-bs-toggle="modal"
                                data-bs-target="#modalImage" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card image-card">
                    <div class="row">
                        <div class="col header-title-text">{{'METER_VALIDATION.PICTURES.NAMEPLATE' | translate}}</div>
                    </div>
                    <div class="row">
                        <div>
                            <img src="{{ getImageByType(ImageType.NameplatePicture)?.url }}"
                                (click)="showImage(ImageType.NameplatePicture)" data-bs-toggle="modal"
                                data-bs-target="#modalImage" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div class="meter-validation-header body-header">
        <div class="meter-validation-header-info">
            <div class="meter-validation-info">
                <div class="name">{{'METER_VALIDATION.LOCATION.TITLE' | translate}}</div>
            </div>
        </div>
    </div>
    <div class="meter-validation-body">
        <div class="row">
            <div class="col-md-6 col-lg-4 col-xl-3">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'METER_VALIDATION.LOCATION.QUESTION' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ (selectedMeterValidation.installationAddress ? 'COMMON.NO' : 'COMMON.YES') | translate }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3" *ngIf="selectedMeterValidation.installationAddress">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'METER_VALIDATION.LOCATION.CORRECT' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ selectedMeterValidation.installationAddress }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="permissionsService.dtConfirmationEnabled" class="meter-validation-header body-header">
        <div class="meter-validation-header-info">
            <div class="meter-validation-info">
                <div class="name">{{'METER_VALIDATION.DT.TITLE' | translate}}</div>
            </div>
        </div>
    </div>
    <div *ngIf="permissionsService.dtConfirmationEnabled" class="meter-validation-body">
        <div class="row">
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'METER_VALIDATION.DT.QUESTION' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ (selectedMeterValidation.correctDtName ? 'COMMON.NO' : 'COMMON.YES') | translate }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3" *ngIf="selectedMeterValidation.correctDtName">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'COMMON.FEEDER_VOLTAGE' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ selectedMeterValidation.correctFeederVoltage }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3" *ngIf="selectedMeterValidation.correctDtName">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'COMMON.MBC_DETAILS.FEEDER_NAME' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ selectedMeterValidation.correctFeederName }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3" *ngIf="selectedMeterValidation.correctDtName">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'COMMON.DT_NAME' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ selectedMeterValidation.correctDtName }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="permissionsService.meterValidationTamperEnabled" class="meter-validation-header body-header">
        <div class="meter-validation-header-info">
            <div class="meter-validation-info">
                <div class="name">{{'METER_VALIDATION.TAMPER.TITLE' | translate}}</div>
            </div>
        </div>
    </div>
    <div *ngIf="permissionsService.meterValidationTamperEnabled" class="meter-validation-body">
        <div class="row">
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'METER_VALIDATION.TAMPER.QUESTION' | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ (selectedMeterValidation.isTampered ? 'COMMON.YES' : 'COMMON.NO') | translate }}
                        </div>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="selectedMeterValidation.isTampered">
                <div class="col-sm-6 col-md-4 col-lg-3" *ngFor="let tamper of tamperImages; index as i">
                    <div class="card">
                        <div class="row">
                            <div>
                                <img alt="Tamper image" src="{{ getTamperImage(i)?.url }}"
                                    (click)="showImage(undefined, i)" data-bs-toggle="modal"
                                    data-bs-target="#modalImage" />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="meter-validation-header body-header">
        <div class="meter-validation-header-info">
            <div class="meter-validation-info">
                <div class="name">{{'METER_VALIDATION.USER_ACTIVITY.TITLE' | translate}}</div>
            </div>
        </div>
    </div>
    <div class="meter-validation-body">
        <div class="row">
            <div class="col-sm-6 col-md-4 col-lg-3">
                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{'METER_VALIDATION.USER_ACTIVITY.CAPTURED' | translate}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{ selectedMeterValidation.submittedBy }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">

                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{
                            (selectedMeterValidation.status.toString() == 'Submitted' ?
                            'METER_VALIDATION.USER_ACTIVITY.ASSIGNED'
                            : (selectedMeterValidation.status.toString() == 'Approved' ?
                            'METER_VALIDATION.USER_ACTIVITY.APPROVED_BY' :
                            'METER_VALIDATION.USER_ACTIVITY.REJECTED_BY'))
                            | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{
                            selectedMeterValidation.status.toString() == 'Submitted' ?
                            selectedMeterValidation.assignedUser
                            : selectedMeterValidation.validatedBy
                            }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-4 col-lg-3">

                <div class="card">
                    <div class="row">
                        <div class="col header-title-text">{{
                            (selectedMeterValidation.status.toString() == 'Submitted' ?
                            'METER_VALIDATION.USER_ACTIVITY.SUBMITTED_DATE'
                            : (selectedMeterValidation.status.toString() == 'Approved' ?
                            'METER_VALIDATION.USER_ACTIVITY.APPROVED_DATE' :
                            'METER_VALIDATION.USER_ACTIVITY.REJECTED_DATE'))
                            | translate}}</div>
                    </div>
                    <div class="row">
                        <div class="green-text">
                            {{
                            (selectedMeterValidation.status.toString() == 'Submitted' ?
                            selectedMeterValidation.submittedDateTime
                            : selectedMeterValidation.validationDateTime) | date
                            }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal modalMap" id="showMap" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" #closeAddModal class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <app-building-map [setMapVisibility]="isMapVisible" [longitude]="selectedMeterValidation.longitude"
                    [latitude]="selectedMeterValidation.latitude"></app-building-map>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalImage" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalFade()"
    (shown.bs.modal)="onModalOpen()">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content modal-image">
            <div class="modal-body modal-body-image">
                <div class="image-container" [style.transform]="'rotate(' + currentRotation + 'deg)'">
                    <lib-ngx-image-zoom [zoomMode]="'hover-freeze'" [fullImage]="selectedImage?.url"
                        [thumbImage]="selectedImage?.url" [magnification]="3">
                    </lib-ngx-image-zoom>
                </div>
                <div class="rotate-div">
                    <button class="btn btn-primary left-button" (click)="rotateLeft()">&lt;</button>
                    <button class="btn btn-primary right-button" (click)="rotateRight()">&gt;</button>
                </div>
                <div class="image-info" *ngIf="selectedImage?.physicalAddress">
                    <div>{{ 'COMMON.MBC_DETAILS.PHYSICAL_ADDRESS' | translate }}: <b>{{ selectedImage?.physicalAddress }}</b></div>
                    <div>Latitude: <b>{{ selectedImage?.latitude }}</b></div>
                    <div>Longitude: <b>{{ selectedImage?.longitude }}</b></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalApprove" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'METER_VALIDATION.DETAILS.APPROVE' | translate}}</h5>
      </div>
      <div>
        <div>
          {{'METER_VALIDATION.DETAILS.APPROVE_PROMPT' | translate}}
        </div>
        <div class="row">
          <div class="col-6">
            <button type="button" class="btn btn-outline-danger" style="width: 100%;" data-bs-dismiss="modal">
              {{'COMMON.CANCEL' | translate}}
            </button>
          </div>
          <div class="col-6">
            <button type="button" class="btn btn-success" style="width: 100%;" (click)="approve()">
              {{'METER_VALIDATION.DETAILS.APPROVE' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalReject" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'METER_VALIDATION.DETAILS.REJECT' | translate}}</h5>
      </div>
      <form id="rejectForm" ngNativeValidate (submit)="reject()">
        <div class="form-item form-floating mb-3">
          <select id="rejectOption" class="form-select" (change)="onOptionChange($event)">
            <option [value]="'capturedUser'"> {{ 'COMMON.REJECT_OPTIONS.CAPTURED_USER' | translate }} </option>
            <option [value]="'fieldAgent'"> {{ 'COMMON.REJECT_OPTIONS.FIELD_AGENT' | translate }} </option>
          </select>
        </div>
        <div *ngIf="rejectToOption === 'fieldAgent'" class="form-item form-floating mb-3">
          <div class="form-floating form-item">
            <input type="text" name="filterText" [(ngModel)]="filterText" class="form-control filter-field"
              [ngClass]="{ 'valid-input': tempAssignedUserId != 0 }" id="floatingInput"
              (ngModelChange)="filterMobileUsers()" placeholder=" " />
            <label for="floatingInput">{{'COMMON.FIELD_AGENT' | translate}}</label>

            <div class="filtered-agent-list" *ngIf="filterText && filterText.length > 2 && isDropdownOpened"
              #dropdownContainer>
              <div click-stop-propagation class="agent-name" (click)="selectFieldAgent(u.id)"
                *ngFor="let u of mobileUsers">
                {{ u.firstName }} {{ u.lastName }}
              </div>
            </div>
          </div>
        </div>
        <label class="mb-3">
          {{'METER_VALIDATION.DETAILS.REJECT_PROMPT' | translate}}
        </label>
        <div class="mb-3">
          <textarea required rows="10" cols="50" name="note" [(ngModel)]="rejectionNote"
            class="form-control"></textarea>
        </div>
        <div class="row">
          <div class="col-6">
            <button type="button" data-bs-dismiss="modal" style="width: 100%;"
              class="btn btn-outline-danger">{{'COMMON.CANCEL' | translate}}</button>
          </div>
          <div class="col-6">
            <button type="submit" class="btn btn-danger" style="width: 100%;">
              {{'METER_VALIDATION.DETAILS.REJECT' | translate}}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>